import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AumicoCoreProvider, NotificationType } from '@modeso/aumico-lib-core-fe';
import { sendVerificationMail } from '@modeso/aumico-lib-users-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ofType } from '@ngrx/effects';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { first } from 'rxjs';
import { IconName } from '../../../enums/IconName.enum';
import { EmailServices } from '../../../enums/emailServices.enum';
import { ExternalLinks } from '../../../enums/externalLinks.enum';
import { IMailButton } from '../../../interfaces/IMailButton.interface';
import { localizationKeys } from './../../../utils/localizationKeys';
import { BasePageComponent } from './../../base.page';

type Unpacked<T> = T extends (infer U)[] ? U : T;

@UntilDestroy()
@Component({
    selector: 'app-page-confirm-account',
    templateUrl: './confirm-account.page.html',
    styleUrls: ['./confirm-account.page.scss'],
})
export class ConfirmAccountPage extends BasePageComponent implements OnInit {
    localizationKeys = localizationKeys;

    questionTextKey = this.localizationKeys.aumico_reports_registration_confirmation_bottom_question;
    questionButtonTextKey = this.localizationKeys.aumico_reports_registration_confirmation_bottom_question_button;

    mailButtonsDataArray: IMailButton[] = [
        {
            icon: IconName.GMAIL,
            text: EmailServices.GMAIL,
            link: ExternalLinks.GMAIL,
        },
        {
            icon: IconName.OUTLOOK,
            text: EmailServices.OUTLOOK,
            link: ExternalLinks.OUTLOOK,
        },
        {
            icon: IconName.YAHOO,
            text: EmailServices.YAHOO,
            link: ExternalLinks.YAHOO,
        },
    ];
    private email: string;
    constructor(
        injector: Injector,
        protected override router: Router,
        private readonly coreProvider: AumicoCoreProvider,
        private gtmService: GoogleTagManagerService,
    ) {
        super(injector);
    }

    override ngOnInit(): void {
        this.gtmService.addGtmToDom();
        super.ngOnInit();
        this.activatedRoute.queryParams.pipe(first()).subscribe((queryParam) => {
            this.email = queryParam['email'];
        });

        this.actionsListener$
            .pipe(ofType(sendVerificationMail.success), untilDestroyed(this))
            .subscribe(() => this.dispatchSuccessNotification());

        this.actionsListener$
            .pipe(ofType(sendVerificationMail.failure), untilDestroyed(this))
            .subscribe(() => this.dispatchErrorNotification());
    }

    public onMailButtonClicked(mailItem: IMailButton): void {
        window.open(mailItem.link, '_blank');
    }

    public onResendPressed(): void {
        this.authProvider.dispatchResendVerificationMail(this.email);
    }

    private dispatchSuccessNotification(): void {
        this.coreProvider.dispatchAddNotification(
            this.localizationKeys.aumico_notification_resend_email_success,
            this.localizationKeys.aumico_notification_resend_email_success_content,
            NotificationType.SUCCESS,
        );
    }

    private dispatchErrorNotification(): void {
        this.coreProvider.dispatchAddNotification(
            this.localizationKeys.aumico_notification_resend_email_failure,
            this.localizationKeys.aumico_notification_resend_email_failed_content,
            NotificationType.ERROR,
        );
    }
}
